import filterPortfolio from "../FilterPortfolio";

const PortfolioFilters = () => {
  const filters = [
    { name: "All", filter: "*" },
    { name: "React.js", filter: ".ReactJs" },
    { name: "JavaScript", filter: ".JavaScript" },
    { name: "Next.js", filter: ".NextJs" },
    { name: "JQuery", filter: ".JQuery" },
    { name: "PHP", filter: ".PHP" },
    { name: "WordPress", filter: ".WordPress" },
    { name: "SMM", filter: ".SMM" },
  ];

  return (
    <div className="row">
      <div className="col-lg-12 d-flex justify-content-center">
        <ul id="portfolio-flters">
          {filters.map((filter, index) => (
            <li
              key={index}
              data-filter={filter.filter}
              className={filter.filter === "*" ? "filter-active" : ""}
              onClick={(e) => filterPortfolio(e.target)}
            >
              {filter.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PortfolioFilters;
